import { SidePanel, StatusPill, IconButton } from '@hue/design-system';
import { useQuery } from '@tanstack/react-query';
import { CalendarPlus } from 'lucide-react';
import { useState } from 'react';
import { getApiError, salesApi, type Sale } from '../../lib/api.js';
import { formatDateTime } from '../../lib/time-zone.js';

export function SaleServicesButton({
  sale,
  onSchedule,
}: {
  sale: Sale;
  onSchedule: (saleItemUnitId: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const services = useQuery({
    queryKey: ['company', 'sales', 'services', sale.id],
    queryFn: () => salesApi.services(sale.id),
    enabled: open,
    retry: false,
  });
  return (
    <>
      <IconButton label="Agendar serviços" icon={<CalendarPlus />} onClick={() => setOpen(true)} />
      <SidePanel
        open={open}
        onOpenChange={setOpen}
        title={`Serviços da venda ${String(sale.number)}`}
        description="Cada serviço vendido ganha um horário na Agenda, sem sinal: o pagamento continua nesta venda."
      >
        {services.isLoading ? (
          <p role="status">Carregando serviços…</p>
        ) : services.error ? (
          <p role="alert" className="text-danger">
            {getApiError(services.error)}
          </p>
        ) : (
          <ol className="space-y-3" aria-label="Serviços vendidos">
            {(services.data ?? []).map((unit) => (
              <li
                key={unit.saleItemUnitId}
                className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-surface-border p-4"
              >
                <div>
                  <p className="text-sm font-semibold">
                    {unit.serviceDisplayName}
                    {unit.quantity > 1
                      ? ` · ${String(unit.position)} de ${String(unit.quantity)}`
                      : ''}
                  </p>
                  {unit.appointment ? (
                    <p className="mt-1 text-xs text-content-muted">
                      {formatDateTime(unit.appointment.startsAt, unit.appointment.timeZone)}
                    </p>
                  ) : null}
                </div>
                {unit.appointment ? (
                  <StatusPill tone="positive">Agendado</StatusPill>
                ) : (
                  <IconButton
                    label={`Agendar ${unit.serviceDisplayName} ${String(unit.position)}`}
                    icon={<CalendarPlus />}
                    onClick={() => onSchedule(unit.saleItemUnitId)}
                  />
                )}
              </li>
            ))}
          </ol>
        )}
      </SidePanel>
    </>
  );
}
